const RESET_TOKEN_PATH = /^\/reset-password\/.+/;

export const sanitizeAnalyticsPath = (pathname: string): string =>
  RESET_TOKEN_PATH.test(pathname) ? '/reset-password' : pathname;

export const sanitizeAnalyticsHref = (href: string): string => {
  try {
    const url = new URL(href);
    if (RESET_TOKEN_PATH.test(url.pathname)) {
      url.pathname = '/reset-password';
    }
    return url.toString();
  } catch {
    return href;
  }
};
